import { Component, ChangeDetectorRef } from '@angular/core';
import { IDoesFilterPassParams, IFilterParams } from 'ag-grid-community';
import { IFilterAngularComp } from 'ag-grid-angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

interface DropdownFilterParams extends IFilterParams {
  options?: string[];
  isGridLoading?: () => boolean;
}

@Component({
  selector: 'app-dropdown-filter',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './dropdown-filter.component.html',
  styleUrls: ['./dropdown-filter.component.css']
})
export class DropdownFilterComponent implements IFilterAngularComp {
  private params!: DropdownFilterParams;
  selectedValue: string = '';
  options: string[] = [];
  private checkLoadingInterval: any;

  constructor(private cdr: ChangeDetectorRef) {}

  agInit(params: DropdownFilterParams): void {
    this.params = params;
    this.options = params.options || [];

    this.checkLoadingInterval = setInterval(() => {
      this.cdr.detectChanges();
    }, 100);
  }

  ngOnDestroy(): void {
    if (this.checkLoadingInterval) {
      clearInterval(this.checkLoadingInterval);
    }
  }

  isGridLoading(): boolean {
    return this.params.isGridLoading ? this.params.isGridLoading() : false;
  }

  canApply(): boolean {
    return !this.isGridLoading();
  }

  isFilterActive(): boolean {
    return this.selectedValue !== '';
  }

  doesFilterPass(params: IDoesFilterPassParams): boolean {
    if (!this.selectedValue) return true;
    
    const field = this.params.colDef.field;
    const value = field ? params.data[field] : null;
    
    return value?.toString() === this.selectedValue;
  }

  getModel() {
    if (!this.isFilterActive()) return null;
    
    const numValue = parseInt(this.selectedValue);
    const filterValue = !isNaN(numValue) && this.selectedValue === numValue.toString() 
      ? numValue 
      : this.selectedValue;
    
    return { 
      filterType: typeof filterValue === 'number' ? 'number' : 'text',
      type: 'equals',
      filter: filterValue 
    };
  }

  setModel(model: any): void {
    this.selectedValue = model ? model.filter.toString() : '';
  }

  onApply(): void {
    if (this.canApply()) {
      this.params.filterChangedCallback();
      
      if ((this.params as any).hidePopup) {
        (this.params as any).hidePopup();
      }
    }
  }
}